/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {stopTimecardBreak} from '../api'

export const useMutationStopTimecardBreak = createReactQueryMutationHook('stopTimecardBreak', stopTimecardBreak)
